// 字典常量
export const menuItemsOpenService = [{
    key: '1',
    label: '开通服务',
    path: '/service-management',
    child: [
        {
            key: '1-1',
            label: '',
            path: '/application-form',
        },
    ],
}];

export const menuItems = [{
    key: '1',
    label: '服务管理',
    path: '/service-management',
}, {
    key: '2',
    label: '数据统计',
    path: '/data-statistics',
}, {
    key: '3',
    label: '告警管理',
    path: '/alarm-management',
    child: [
        {
            key: '3-1',
            label: '',
            path: '/alarm-list',
        },
    ],
}, {
    key: '4',
    label: '日志查询',
    path: '/log-query',
}];

export const dateFormat = 'YYYY-MM-DD';

// 前端配置
export const useFeCtype: {[key: string]: string} = {
    0: '否', // 优先使用后端配置的验证码类型
    1: '是', // 优先使用前端配置验证码类型
};

// 前端配置
export const useFeCtypeShow: {[key: string]: string} = {
    0: '不启用', // 优先使用后端配置的验证码类型
    1: '启用', // 优先使用前端配置验证码类型
};

// 场景类型
export const sceneTypeObj: {[key: string]: string} = {
    1: '账号场景',
    2: '营销活动',
    3: '发帖点赞',
    4: '短信场景',
    5: '内容保护场景',
    6: '其他场景',
};

// 验证码类型
export const captchaTypeObj: {[key: string]: string} = {
    // 'b_proven': '一点即过验证',
    'b_track_match': '轨迹滑块',
    'b_click': '数字点选',
    'b_word_click': '文字点选',
    'b_track_draw': '轨迹绘制',
};

export const alarmTargetObj = {
    '1h_request_cnt': '请求量',
    '1h_verify_cnt': '验证量',
    '1h_pass_cnt': '验证通过量',
    '1h_fail_cnt': '验证拦截量',
    '1h_fail_pct': '验证拦截率',
};

// 验证结果：
export const verifyResultObj: {[key: number]: string} = {
    [-1]: '不涉及',
    0: '未通过',
    1: '通过',
};

// 注释：
export const getOptions = (dataObj: {[key: string]: string}) => Object.entries(dataObj || {}).map(([key, value]) => ({
    label: value,
    value: key,
}));
// 取captchaTypeObj中的key形成新数组
export const getObjKeys = (dataObj: {[key: string]: string}) => Object.keys(dataObj || {});

export const useFeCtypeShowOptions = [{
    label: '启用',
    value: 1,
}, {
    label: '不启用',
    value: 0,
}];

export const sceneTypeOptions = getOptions(sceneTypeObj);
export const captchaTypeOptions = getOptions(captchaTypeObj);

export const initCustomizeCaptcha = getObjKeys(captchaTypeObj);

export const alarmTargetOptions = getOptions(alarmTargetObj);

export const daysDict = {
    'today': 0,
    'yesterday': 1,
    '7days': 7,
    '30days': 30,
    '90days': 90,
    '180days': 180,
    '365days': 365,
};

export const siderStyle: React.CSSProperties = {
    height: 'calc(100vh - 50px)',
    // position: 'sticky',
    // insetInlineStart: 0,
    top: 0,
    bottom: 0,
    // scrollbarWidth: 'thin',
    // scrollbarGutter: 'stable',
    fontSize: '14px',
    zIndex: 2,
    boxShadow: '0 2px 8px 0 rgba(7, 12, 20, .12)',
    backgroundColor: '#fff',
};
